export default __webpack_public_path__ + "static/media/Jogo-Do-Bicho_No-volume_1.4f6836ce.svg";